import React from 'react';
import { shape, func } from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { getStoreTemplate } from '../helpers/store-helper';
import { dataModel } from '../../components/dataModel';
import { productShape } from '../helpers/pod-fulfillment-utils';
import { EmptyStoreMessage } from '../partials/store/EmptyStoreMessage';
import './fulfillment-pod-store.scss';

export const FulfillmentPodStore = ({ product, onCheckNearbyStoresClick }) => {
  const { storeId, defaultStoreId } = useStore();
  const StoreComponent = getStoreTemplate({
    product,
    storeId: storeId || defaultStoreId
  }); //eslint-disable-line

  if (!StoreComponent) {
    return EmptyStoreMessage;
  }

  return (
    <StoreComponent
      product={product}
      onCheckNearbyStoresClick={onCheckNearbyStoresClick}
    />
  );
};

FulfillmentPodStore.propTypes = {
  product: shape({ productShape }).isRequired,
  onCheckNearbyStoresClick: func,
};

FulfillmentPodStore.defaultProps = {
  onCheckNearbyStoresClick: () => {},
};

FulfillmentPodStore.dataModel = dataModel;
